import { graphql } from 'react-relay';

export const ProjectFragment = graphql`
    fragment ProjectFragment on Project {
        id
        name
        number
        status
        statusItem {
            name
            code
            id
        }
    }
`;
